var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16117 6.16117C8.42185 3.90048 11.5486 2.5 15 2.5C18.4514 2.5 21.5782 3.90048 23.8388 6.16117C26.0995 8.42185 27.5 11.5486 27.5 15C27.5 18.4514 26.0995 21.5782 23.8388 23.8388C21.5782 26.0995 18.4514 27.5 15 27.5C11.5486 27.5 8.42185 26.0995 6.16117 23.8388C3.90048 21.5782 2.5 18.4514 2.5 15C2.5 11.5486 3.90048 8.42185 6.16117 6.16117ZM15 5C12.2382 5 9.73995 6.11792 7.92893 7.92893C6.11792 9.73994 5 12.2382 5 15C5 17.7618 6.11792 20.2601 7.92893 22.0711C9.73995 23.8821 12.2382 25 15 25C17.7618 25 20.2601 23.8821 22.0711 22.0711C23.8821 20.2601 25 17.7618 25 15C25 12.2382 23.8821 9.73995 22.0711 7.92893C20.2601 6.11792 17.7618 5 15 5Z",
    fill: "url(#paint0_linear_0_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.75C15.6904 8.75 16.25 9.30964 16.25 10V15C16.25 15.6904 15.6904 16.25 15 16.25C14.3096 16.25 13.75 15.6904 13.75 15L13.75 10C13.75 9.30964 14.3096 8.75 15 8.75Z",
    fill: "url(#paint1_linear_0_88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1161 14.1161C14.6043 13.628 15.3957 13.628 15.8839 14.1161L18.3839 16.6161C18.872 17.1043 18.872 17.8957 18.3839 18.3839C17.8957 18.872 17.1043 18.872 16.6161 18.3839L14.1161 15.8839C13.628 15.3957 13.628 14.6043 14.1161 14.1161Z",
    fill: "url(#paint2_linear_0_88)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_88",
    x1: 2.92049,
    y1: 2.49999,
    x2: 28.0358,
    y2: 3.05041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_88",
    x1: 13.792,
    y1: 8.75,
    x2: 16.3047,
    y2: 8.76835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_88",
    x1: 13.8341,
    y1: 13.75,
    x2: 18.8572,
    y2: 13.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.99be170be679955d6b1070833aa521e2.svg";
export { ForwardRef as ReactComponent };